import React from 'react';
import { Input, Button } from 'antd';
import { SendOutlined } from '@ant-design/icons';

interface MessageInputAreaProps {
  message: string;
  onMessageChange: (value: string) => void;
  onSendMessage: () => void;
  isLoading: boolean;
}

export const MessageInputArea: React.FC<MessageInputAreaProps> = ({
  message,
  onMessageChange,
  onSendMessage,
  isLoading
}) => {
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSendMessage();
    }
  };

  return (
    <div className="message-input-area">
      <Input
        placeholder="Message Sales Assistant..."
        value={message}
        onChange={(e) => onMessageChange(e.target.value)}
        onKeyPress={handleKeyPress}
        disabled={isLoading}
        className="message-input"
      />
      <Button
        type="primary"
        icon={<SendOutlined />}
        onClick={onSendMessage}
        disabled={!message.trim() || isLoading}
        loading={isLoading}
        className="send-button"
      />
    </div>
  );
};
